import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './juniper-insights-skeleton.scss';

const CHIP_WIDTHS: string[] = [
  '22rem',
  '28rem',
  '20rem',
  '24rem',
  '23rem',
  '20rem',
  '7rem',
];

const JuniperInsightsSkeleton = () => {
  return (
    <div
      className="juniper-insights-skeleton"
      aria-busy="true"
      aria-live="polite"
    >
      <Skeleton variant="rect" className="juniper-insights-skeleton-badge" />

      <Skeleton variant="rect" className="juniper-insights-skeleton-panel" />

      <div className="juniper-insights-skeleton-chips">
        {CHIP_WIDTHS.map((width: string, index: number) => (
          <Skeleton
            key={`juniper-insights-skeleton-chip-${index}`}
            variant="rect"
            width={width}
            className="juniper-insights-skeleton-chip"
          />
        ))}
      </div>

      <div className="juniper-insights-skeleton-input">
        <Skeleton variant="rect" className="juniper-insights-skeleton-field" />
        <Skeleton variant="rect" className="juniper-insights-skeleton-send" />
      </div>
    </div>
  );
};

export default JuniperInsightsSkeleton;